module.exports = __webpack_public_path__ + "img/28a.0ea7006c.png";